import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  TextField,
  Button,
  Grid,
  Box,
  Alert,
  Snackbar,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import AppAppBar from "../homePage/AppAppBar";
import Footer from "../homePage/Footer";

const isValidIndianPhoneNumber = (phone) => {
  const phoneRegex = /^[6-9]\d{9}$/;
  return phoneRegex.test(phone);
};

const ContactUs = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    companyName: "",
    subject: "",
    message: "",
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState(""); // State for success message
  const [openSuccessSnackbar, setOpenSuccessSnackbar] = useState(false); // Snackbar visibility

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top when the component is mounted
  }, []);

  const handleChange = (e) => {
    if (e.target.name === "phone") {
      const phoneInput = e.target.value;
      const numericValue = phoneInput.replace(/\D/g, "");

      setFormData({ ...formData, [e.target.name]: numericValue });
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form fields
    if (
      !formData.firstName ||
      !formData.lastName ||
      !formData.phone ||
      !formData.email ||
      !formData.companyName ||
      !formData.subject ||
      !formData.message
    ) {
      setErrorMessage(
        "All fields are mandatory. Please fill in all the fields."
      );
      return;
    }

    if (!isValidIndianPhoneNumber(formData.phone)) {
      setErrorMessage("Please enter a valid phone number.");
      return;
    }

    if (
      formData.companyName.length < 3 ||
      formData.subject.length < 3 ||
      formData.message.length < 3
    ) {
      setErrorMessage(
        "Company Name, Subject, and Message should have at least 3 characters."
      );
      return;
    }

    try {
      const response = await fetch(
        "https://nexensus.club/cbi/api/contact/sendMail",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const data = await response.json(); // Parse the response data

      if (response.ok && data.statusCode === 1) {
        setSuccessMessage(data.message); // Shows "successfully" message from the API
        setOpenSuccessSnackbar(true); // Show success snackbar
        setFormData({
          firstName: "",
          lastName: "",
          phone: "",
          email: "",
          companyName: "",
          subject: "",
          message: "",
        });
        setErrorMessage(""); // Clear any previous error messages
      } else {
        alert(data.message || "Failed to send message. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred. Please try again later.");
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setErrorMessage("");
    }, 2000);
    return () => clearTimeout(timer);
  }, [errorMessage]);

  // Handle closing of success snackbar
  const handleCloseSuccessSnackbar = () => {
    setOpenSuccessSnackbar(false);
  };

  return (
    <>
      <Container maxWidth="lg">
        <AppAppBar
          showSubMenu={false}
          showPricing={true}
          showPrivacy={true}
          showTermsofService={true}
        />

        <Grid container spacing={2}>
          <Grid item xs={12} md={6} sx={{ order: { xs: 2, md: 1 } }}>
            <Box
              sx={{
                mt: { xs: 2, md: 16 },
                mb: 4,
              }}
            >
              <Typography variant="body2" gutterBottom>
                We are collecting this personal information in order to respond
                to the enquiry you are sending via this form. We understand the
                importance of protecting your information and will use your
                information for the sole purpose of responding to your enquiry.
                <br />
                <br />
                <span style={{ marginLeft: "0em" }}>
                  Mail Us at :-{" "}
                  <a
                    href="mailto:info@epconsultancy.com"
                    style={{ color: "blue", margin: "1%" }}
                  >
                    info@epconsultancy.com
                  </a>
                  <br />
                  Contact Us at :-{" "}
                  <a href="tel:+911147542465" style={{ color: "blue" }}>
                    {"      "}+91-11-47542465
                  </a>
                  ,
                  <a href="tel:+919773848451" style={{ color: "blue" }}>
                    {"      "}+919773848451
                  </a>
                  ,
                  <a href="tel:+919311401985" style={{ color: "blue" }}>
                    {"      "}+919311401985
                  </a>
                  .
                </span>
              </Typography>

              <Box
                sx={{
                  mt: 4,
                  height: "250px",
                  width: "100%",
                }}
              >
                <iframe
                  width="100%"
                  height="100%"
                  frameBorder="0"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3504.0653935198247!2d77.18647695013803!3d28.567798982357186!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1d841e2915ed%3A0xcfad4cb937f37055!2sNexensus!5e0!3m2!1sen!2sin!4v1583227117018!5m2!1sen!2sin" // Replace with your location and API key
                  allowFullScreen
                ></iframe>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={6} sx={{ order: { xs: 1, md: 2 } }}>
            <Box
              sx={{
                mt: { xs: 10, md: 12 },
                mb: 4,
              }}
            >
              <Typography variant="h4" align="center" gutterBottom>
                Get In Touch
              </Typography>
              {/* Show error message */}
              {errorMessage && (
                <Alert severity="error" align="center" gutterBottom mb={2}>
                  {errorMessage}
                </Alert>
              )}
              <form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="First Name"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Last Name"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      inputProps={{
                        type: "tel",
                        maxLength: 10,
                        pattern: "[6-9]{1}[0-9]{9}",
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Email"
                      name="email"
                      type="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Company Name"
                      name="companyName"
                      value={formData.companyName}
                      onChange={handleChange}
                      required
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Message"
                      name="message"
                      multiline
                      rows={4}
                      value={formData.message}
                      onChange={handleChange}
                      required
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      endIcon={<SendIcon />}
                      fullWidth
                    >
                      Send Message
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </Box>
          </Grid>
        </Grid>
      </Container>

      {/* Success Snackbar */}
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={openSuccessSnackbar}
        autoHideDuration={2000}
        onClose={handleCloseSuccessSnackbar}
      >
        <Alert onClose={handleCloseSuccessSnackbar} severity="success">
          {successMessage}
        </Alert>
      </Snackbar>

      <Footer />
    </>
  );
};

export default ContactUs;
